module.exports = __webpack_public_path__ + "public/images/spanish.4feb934d4180e5477092a5f84206a7b9.png";